import { Command } from '@/app/common/base/command'

export class LoginFromAccelerateCommand extends Command {
    
    public async run(accessToken: string, refreshToken: string): Promise<void> {
        await this.store.dispatch('auth/login', { accessToken, refreshToken })
    }

}
